import { HEADER_ACCENT_STYLES } from '../../theme/header-accent-styles';
import { useSettingsContext } from '../../theme/settings-drawer';
import { Box } from '@mui/material';

export const HeaderAccent = () => {
  const { currentHeaderAccentStyle } = useSettingsContext();

  if (currentHeaderAccentStyle === HEADER_ACCENT_STYLES.none) {
    return null;
  }

  return (
    <Box
      sx={{
        position: 'relative',
        overflow: 'hidden',
        height: '8px',
        ...currentHeaderAccentStyle,
      }}
    />
  );
};
